if (!customElements.get('footer-collapsible')) {
  customElements.define(
    'footer-collapsible',
    class FooterCollapsible extends HTMLElement {
      constructor() {
        super();
        this.header = this.querySelector('.footer-collapser_header');
        this.contentWrapper = this.querySelector('.footer-collapser_content-wrapper');
        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.header || !this.contentWrapper) return;

        this.header.addEventListener('click', this.toggle.bind(this));
        this.mql.addEventListener('change', this.onBreakpointChange.bind(this));

        this.onBreakpointChange();
      }

      toggle() {
        if (this.mql.matches) return;

        const isOpen = this.header.classList.contains('active');
        if (isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.header.classList.add('active');
        this.contentWrapper.classList.add('active');
        this.header.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.header.classList.remove('active');
        this.contentWrapper.classList.remove('active');
        this.header.setAttribute('aria-expanded', 'false');
      }

      onBreakpointChange() {
        if (this.mql.matches) {
          this.header.classList.remove('active');
          this.contentWrapper.classList.remove('active');
          this.header.removeAttribute('aria-expanded');
        } else {
          this.close();
        }
      }
    }
  );
}
